var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgShowMoreBlue = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "18px",
    viewBox: "0 0 10 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "show_more-blue")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.59,2.83 L7.76,6 L9.17,4.59 L4.59,0 L0,4.59 L1.42,6 L4.59,2.83 Z M4.59,15.17 L1.42,12 L0.01,13.41 L4.59,18 L9.18,13.41 L7.76,12 L4.59,15.17 Z",
    id: "show_more",
    fill: "#2962FF"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShowMoreBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/show_more-blue.f47ff352.svg";
export { ForwardRef as ReactComponent };